
import * as React from 'react';
import {IBundle} from "../../data/BundleData";

import './SolutionBundleCard.pcss';
import {ISolutionBundle} from "../../data/SolutionDataSource";
import {handleSpacePressed} from "utils";

interface Props {
  solutionBundle:ISolutionBundle;
  bundle:IBundle;
  onClick:(bundle:IBundle)=>void;
  bundleMaxPoints:number;
  bundleCurrentPoints:number;
  solutionCurrentPoints:number;
}

export const SolutionBundleCard = (props:Props) => {
  const pointsAvailable = props.bundleMaxPoints - props.bundleCurrentPoints;
  const locked = props.solutionBundle.unlockPointValue ? props.solutionBundle.unlockPointValue>props.solutionCurrentPoints : false;
  const completed = 0 < props.bundleMaxPoints && 0===pointsAvailable;

  const onClick = ()=>{ if(!locked) { props.onClick(props.bundle); }}

  const pointsAvailableStatement = `${pointsAvailable} point${pointsAvailable>1?'s':''} available`;
  const pointsCompletedStatement = `Completed for ${props.bundleMaxPoints} point${props.bundleMaxPoints>1?'s':''}`;
  return (
    <div className={"solution-bundle-card"}>
      <div className={"sbc-preview"}>
        <a role={'button'} href={"#"} aria-label={`View ${props.bundle.fullName} ${completed?"(Completed)":""}`}
           onClick={onClick}
           onKeyDown={(e)=>{ handleSpacePressed(e, onClick);}}
        >
          <img src={props.bundle.photo} aria-hidden={"true"} />
        </a>
        {locked &&
          <div className={"locked-panel"}>
            <span className={"material-icons lock"} aria-hidden={"true"}>lock</span>
            <p>Unlocks when you have earned {props.solutionBundle.unlockPointValue} point{props.solutionBundle.unlockPointValue>1?'s':''}</p>
          </div>
        }
        {!locked && completed &&
            <div className={"completed-panel"} onClick={onClick}>
              <span className={"material-icons check_circle"} aria-hidden={"true"}>check_circle</span>
              <p>Completed</p>
            </div>
        }
      </div>
      <div className={"sbc-info"}>
        <h2>{props.bundle.fullName}</h2>
        <h3>{props.bundle.cardSubTitle}</h3>
        {pointsAvailable>0 && <h4 className={`${locked?'locked':''}`}>{pointsAvailableStatement}</h4>}
        {!locked && completed && <h4 className={"completed"}>{pointsCompletedStatement}</h4>}
      </div>
    </div>
  );
}

